/* @jsxImportSource react */

import { StatusChip } from '@packages/shared/src/ui/StatusChip/StatusChip';

export type BadgeDVProps = {
  children: React.ReactNode;
};

export const BadgeDV = ({ children }: BadgeDVProps) => (
  <StatusChip color="success" className="h-2.5 items-center uppercase">
    {children}
  </StatusChip>
);
